import { render } from "./RewardAndExpectation.vue?vue&type=template&id=1bf43e5d&scoped=true"
import script from "./RewardAndExpectation.vue?vue&type=script&lang=js"
export * from "./RewardAndExpectation.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1bf43e5d"

export default script